<div class="container-fluid profile-page">
  <div class="profile-hero">
    <h4 class="mb-1">Mi perfil</h4>
    <p class="mb-0">Gestiona tu seguridad y controla tus sesiones abiertas.</p>
  </div>

  <div class="row row-sm">
    <div class="col-lg-5 col-md-12">
      <div class="card custom-card profile-card">
        <div class="card-header border-bottom">
          <h5 class="mb-0">Seguridad de la cuenta</h5>
        </div>
        <div class="card-body">
          <div class="security-note mb-4">
            <h6 class="mb-1">Cambio de contraseña</h6>
          </div>

          <form [formGroup]="form" (ngSubmit)="guardar()" class="profile-form">
            <div class="form-group">
              <label>Clave actual</label>
              <input type="password" class="form-control" formControlName="passwordActual" autocomplete="current-password">
            </div>

            <div class="form-group">
              <label>Nueva clave</label>
              <input type="password" class="form-control" formControlName="passwordNueva" autocomplete="new-password">
              @if (f['passwordNueva'].touched && f['passwordNueva'].invalid) {
                <small class="text-danger">
                  La nueva clave debe tener al menos 6 caracteres.
                </small>
              }
            </div>

            <div class="form-group mb-3">
              <label>Confirmar nueva clave</label>
              <input type="password" class="form-control" formControlName="passwordConfirmacion" autocomplete="new-password">
            </div>

            <button class="btn btn-primary btn-save" type="submit" [disabled]="guardando">
              {{ guardando ? 'Guardando...' : 'Actualizar clave' }}
            </button>
          </form>
        </div>
      </div>
    </div>

    <div class="col-lg-7 col-md-12">
      <div class="card custom-card sessions-card">
        <div class="card-header border-bottom d-flex align-items-center justify-content-between gap-2">
          <div>
            <h5 class="mb-0">Sesiones abiertas</h5>
            <small class="text-muted">{{ sesiones.length }} sesión(es) detectadas</small>
          </div>
          <button class="btn btn-outline-danger btn-sm" type="button" (click)="revocarOtrasSesiones()" [disabled]="revocandoSesiones || cargandoSesiones || sesiones.length <= 1">
            Cerrar otras sesiones
          </button>
        </div>
        <div class="card-body">
          @if (cargandoSesiones) {
            <div class="loading-state">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 mb-0 text-muted">Cargando sesiones...</p>
            </div>
          }

          @if (!cargandoSesiones && sesiones.length === 0) {
            <div class="empty-state">
              <h6 class="mb-1">Sin sesiones activas</h6>
              <p class="mb-0 text-muted">No hay sesiones abiertas para este usuario.</p>
            </div>
          }

          @if (!cargandoSesiones && sesiones.length > 0) {
            <div class="session-list">
              @for (session of sesiones; track session) {
                <div class="session-item">
                  <div class="session-head">
                    <div class="session-title-wrap">
                      <h6 class="mb-1">
                        {{ session.deviceName || 'Dispositivo no identificado' }}
                        @if (session.isCurrent) {
                          <span class="badge badge-current">Sesión actual</span>
                        }
                      </h6>
                      <p class="mb-0 text-muted small">{{ session.userAgent || 'Sin user agent' }}</p>
                    </div>
                    <button
                      class="btn btn-sm btn-outline-danger btn-revoke"
                      type="button"
                      (click)="revocarSesion(session)"
                      [disabled]="revocandoSesiones">
                      Cerrar
                    </button>
                  </div>
                  <div class="session-meta mt-3">
                    <span class="meta-chip"><b>Sucursal:</b> {{ session.sucursalNombre || 'N/D' }}</span>
                    <span class="meta-chip"><b>IP:</b> {{ session.ipAddress || 'N/D' }}</span>
                    <span class="meta-chip"><b>Inicio:</b> {{ session.createdAt | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                    <span class="meta-chip"><b>Última actividad:</b> {{ session.lastActivityAt | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                    <span class="meta-chip"><b>Expira:</b> {{ session.expiresAt | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
